var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1439_17610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0.649351V0.485601C6 0.214568 5.7811 0 5.51731 0H0.482694C0.213283 0 0 0.220215 0 0.485601V9.24337H12V1.13495C12 0.863919 11.7811 0.649351 11.5173 0.649351H6Z",
    fill: "#FFDF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.579 1.34952H0.533203V9.33371H11.579V1.34952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82601 2.34895L5.6464 2.84585H0.482694C0.213283 2.84585 0 3.06606 0 3.33145V9.5144C0 9.78543 0.218896 10 0.482694 10H11.5173C11.7867 10 12 9.77978 12 9.5144V2.5127C12 2.24167 11.7811 2.0271 11.5173 2.0271H6.28625C6.08419 2.0271 5.89897 2.15697 5.83162 2.34895H5.82601Z",
    fill: "#FFCC01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1439_17610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.c09fc91882b46fe0105256ed7e2b921c.svg";
export { ForwardRef as ReactComponent };